import { LogOut } from 'lucide-react'

import type { AuthUser } from '../api/auth'
import { de } from '../i18n/de'

/** Who is signed in, and the way out. Renders nothing when SSO is off. */
export function UserMenu({ user, onSignOut }: { user: AuthUser; onSignOut: () => void }) {
  const initials = (user.name || user.username || '?')
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')

  return (
    <div className="flex items-center gap-2">
      <span
        className="flex h-7 w-7 items-center justify-center rounded-full bg-indigo-100 text-xs font-semibold text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300"
        aria-hidden
      >
        {initials}
      </span>
      <span
        className="hidden text-sm text-slate-600 sm:inline dark:text-slate-400"
        title={user.email ?? user.username ?? undefined}
      >
        {user.name}
      </span>
      <button
        type="button"
        onClick={onSignOut}
        title={de.auth.signOut}
        aria-label={de.auth.signOut}
        className="rounded-lg p-1.5 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
      >
        <LogOut className="h-4 w-4" aria-hidden />
      </button>
    </div>
  )
}
